import { useContext, useMemo } from 'react';
import { UserContext } from '../../auth/UserContext';
import {
    ADMINISTRATION,
    LIGHTING_PROFESSIONAL,
    PLANNING,
    PRODUCTION_PROFESSIONAL,
    PROFILES,
    RESERVATION_PROFESSIONAL,
    SUPPLIER
} from '../../nav/apps';
import { AllPermissions } from '../../auth/api';
import { isNil } from 'lodash';
import { Person } from 'sr-types/lib/person/v1/graphql';

export default (item?: Person) => {
    const { application } = useContext(UserContext);
    // In details view we want to show the uploaded resume and hide add resume icon, when the person is managed by Showrunnr and do not have edit permission.
    const isEditAllowed: boolean = item?.security?.allowedActions.includes(AllPermissions.Edit);
    const isResumeIconVisible: boolean = !isNil(item?.resumeReference) || isEditAllowed;

    const showResumeIconApp = useMemo(() => {
        return {
            [ADMINISTRATION.id]: isResumeIconVisible,
            [SUPPLIER.id]: isResumeIconVisible,
            [PLANNING.id]: isResumeIconVisible,
            [PROFILES.id]: isResumeIconVisible,
            [PRODUCTION_PROFESSIONAL.id]: isResumeIconVisible,
            [LIGHTING_PROFESSIONAL.id]: isResumeIconVisible,
            [RESERVATION_PROFESSIONAL.id]: isResumeIconVisible
        };
    }, []);

    return showResumeIconApp[application.id];
};
